/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForTclItsm extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForTclItsm");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForTclItsm.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForTclItsm>): ServiceAccountCredentialsForTclItsm {
        let obj = Object.assign(new ServiceAccountCredentialsForTclItsm(), model);
        ServiceAccountCredentialsForTclItsm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForTclItsm>): ServiceAccountCredentialsForTclItsm {
        if (!model) return null;
        return ServiceAccountCredentialsForTclItsm.newInstance(<ServiceAccountCredentialsForTclItsm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForTclItsm) {
        if (!obj) return;

        models.ServiceAccountCredentialsForTclItsm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForTclItsm): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForTclItsm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Encryption key for User configuration
     */
    encryption_key: string;

}
